import {SearchTypes} from "../../types/common/search.types";
import apiClient from "../apiClient";
import {ResponseDto} from "../ResponseDto";
import {PageTypes} from "../../types/page.types";
import {ChargeTypes} from "../../types/transaction/transaction.types";
import {SettlementDetailTypes} from "../../types/settlement/settlement.types";

export const getMemberSettlementList = (searchData : SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/settlement/getMemberSettlementList",
        {
            params: searchData,
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getMemberSettlementDetail = (settlementCode : string) =>
    apiClient.get<ResponseDto<SettlementDetailTypes>>("/api/front/settlement/getMemberSettlementDetail",
        {
            params: {settlementCode},
            headers: {'Content-Type': 'application/json'}
        }
    );

export const requestCashReceipt = (settlementCode: string) =>
    apiClient.patch<ResponseDto<SettlementDetailTypes>>(
        "/api/front/settlement/requestCashReceipt",
        null,
        {
            params: { settlementCode }
        }
    );